import { FC } from 'react'

import IconHouseComponent from '@/assets/icons/components/IconHouse'
import IconLogoWiggotComponent from '@/assets/icons/components/IconLogoWiggot'
import { composeClasses } from '@/utils/compose-classes'
import As from '@/components/as/As'

export interface LogoProps {
  className?: string
  variant?: 'short' | 'long'
  onClick?: () => void
}

export const Logo: FC<LogoProps> = ({
  className,
  variant = 'long',
  onClick
}) => {
  return (
    <As
      as={onClick ? 'button' : 'div'}
      onClick={onClick}
      className={composeClasses('flex items-center', className)}
    >
      {variant === 'short' ? (
        <IconHouseComponent width="37px" height="37px" />
      ) : (
        <IconLogoWiggotComponent fillColor="#000" width="119px" />
      )}
    </As>
  )
}
